import styled, { keyframes } from 'styled-components';

const theme = {
  surface: '#252836',
  accent: '#ff79c6',
  primary: '#50fa7b',
  text: '#f8f8f2',
  textSecondary: '#bd93f9',
  border: '#44475a',
  bg: '#1C1E2A',
};

const pulseGlow = keyframes`
  0% {
    box-shadow: 0 0 5px ${theme.primary}, 0 0 10px ${theme.primary};
  }
  50% {
    box-shadow: 0 0 20px ${theme.primary}, 0 0 30px ${theme.primary};
  }
  100% {
    box-shadow: 0 0 5px ${theme.primary}, 0 0 10px ${theme.primary};
  }
`;

export const ProgressBarContainer = styled.div`
  // background-color: ${theme.surface};
  background: linear-gradient(135deg, #111827, #1f2937);
  border-radius: 12px;
  padding: 1.5rem 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid ${theme.border};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 1rem;
`;

export const Title = styled.h3`
  font-size: 1.2rem;
  color: ${theme.text};
  margin: 0;
`;

export const PercentageText = styled.span`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${theme.primary};
  filter: drop-shadow(0 0 5px ${theme.primary});
`;

export const BarTrack = styled.div`
  width: 100%;
  height: 12px;
  background-color: ${theme.bg};
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid ${theme.border};
`;

export const BarFill = styled.div`
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  background: linear-gradient(90deg, ${theme.accent} 0%, ${theme.primary} 100%);
  border-radius: 6px;
  transition: width 1.5s cubic-bezier(0.25, 1, 0.5, 1);
  box-shadow: 0 0 15px ${theme.primary};
  animation: ${pulseGlow} 2.5s infinite ease-in-out;
`;

export const InfoFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  font-size: 0.9rem;
  color: ${theme.textSecondary};
`;